/**
 * Tap sounds for the owner's themed looks. Off unless the owner switches them on, and never on the island look.
 * Made from a single oscillator in the browser, so there are no audio files to download. The audio context is only
 * created inside a real tap, which is when phones allow sound at all.
 */
type Mood = 'island' | 'marketing' | 'halloween'
let ctx: AudioContext | null = null
let on = false
let mood: Mood = 'island'
let last = 0
let wired = false

const TAPPABLE = 'button, a[href], summary, [role=switch], [role=radio], [role=button]'

function play(): void {
  const AC = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
  if (!AC) return
  ctx ??= new AC()
  if (ctx.state === 'suspended') void ctx.resume()
  const t = ctx.currentTime
  const tone = (type: OscillatorType, from: number, to: number, length: number, peak: number) => {
    const osc = ctx!.createOscillator()
    const gain = ctx!.createGain()
    osc.type = type
    osc.frequency.setValueAtTime(from, t)
    osc.frequency.exponentialRampToValueAtTime(to, t + length)
    gain.gain.setValueAtTime(0.0001, t)
    gain.gain.exponentialRampToValueAtTime(peak, t + 0.012)
    gain.gain.exponentialRampToValueAtTime(0.0001, t + length)
    osc.connect(gain).connect(ctx!.destination)
    osc.start(t)
    osc.stop(t + length + 0.02)
  }
  if (mood === 'marketing') tone('sine', 520, 940, 0.09, 0.07) // a bubble pop
  else if (mood === 'halloween') { tone('triangle', 240, 90, 0.14, 0.08); tone('sawtooth', 900, 700, 0.07, 0.015) } // a low creak
}

function onTap(event: Event): void {
  if (!on || mood === 'island') return
  const target = event.target as Element | null
  if (!target?.closest(TAPPABLE)) return
  const now = performance.now()
  if (now - last < 60) return
  last = now
  try { play() } catch { /* sound is a nicety; a failure is silent */ }
}

export function configureSound(enabled: boolean, look: Mood): void {
  on = enabled && look !== 'island'
  mood = look
  if (on && !wired) { document.addEventListener('click', onTap, true); wired = true }
}
